export default {"src":"/_next/static/media/character-c.mono.161194fe.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};